<div class="step-two-col">
  <div class="step-col-main">
    <div class="action-panel meeting-action-panel">
      <div class="action-panel-header">
        <i class="fa fa-trophy" style="margin-right:6px;"></i>
        Complete the service
      </div>

      <div class="action-panel-body">
        <p class="action-panel-desc">
          Congratulations on completing the service.
        </p>
        <p class="action-panel-desc">
          <strong>Check the activity report on the right and make sure it is filled in completely before submitting.</strong>
          Once submitted, the report is considered final and the service is closed.
        </p>

        <div class="yes-no-row">
          <button (click)="accept(true)" class="btn btn-primary action-btn">
            <i class="fa fa-check"></i> Complete the service
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="step-col-report">
    <report></report>
  </div>
</div>
<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
